import { render, staticRenderFns } from "./Hikari.vue?vue&type=template&id=3b2910ee&scoped=true&"
import script from "./Hikari.vue?vue&type=script&lang=ts&"
export * from "./Hikari.vue?vue&type=script&lang=ts&"
import style0 from "./Hikari.vue?vue&type=style&index=0&id=3b2910ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2910ee",
  null
  
)

export default component.exports